export default __webpack_public_path__ + "static/media/cube-outline.4e3eb7fa.svg";